export default {
  "box-name": "",
  "public-btn-text1": "即刻交易",
  "public-btn-text2": "查看点差和全部产品",
  screen0: {
    title: "CFD 股息",
    desc: "请注意：CFD 股息收取会在您的MT4账户上的余额里以存款或者取款形式反映出来，注释为 “Dividend”",
  },
  screen1: {
    title: "安全交易",
  },
  screen2: {
    title: "金融世界 触手可及",
  },
  股息调整: "股息调整",
  了解您在股票和指数差价合约交易中的股息调整和分配机制:
    "了解您在指数、ETF与股票差价合约交易中的股息调整和分配机制",
  了解指数差价合约: "了解指数差价合约",
  了解股票差价合约: "了解股票差价合约",
  股息是上市公司从利润或保留资金中定期分配给股东的资金:
    "股息是上市公司或ETF基金向投资者定期分配的收益，涉及股票、指数及ETF差价合约时，系统将根据实际派息情况对持仓账户进行相应的现金股息调整。",
  除息日与交易优化: "除息日与交易优化",
  指数差价合约的除息日由指数提供商根据成分股设定:
    "除息日由指数提供商或ETF、股票公告决定，系统将在当天对多头账户发放现金股息，对空头账户扣除相应金额，提前关注除息安排有助于优化仓位与收益管理。",
  股息调整明细: "股息调整明细",
  差价合约交易中相关产品的股息数据:
    "差价合约交易中相关产品的股息数据，按多头（买入）股息和空头（卖出）股息分开显示",
  交易产品: "交易产品",
  多头股息: "多头股息",
  空头股息: "空头股息",
  除息日: "除息日",
  即刻交易:"即刻交易",
  股息的常见问题:"股息的常见问题",
  qaList: [
    {
      q: "1、什么是股息和除息日？",
      a: [
        "股息是上市公司或ETF基金从利润或资产中分配给投资者的资金。除息日是该资产正式派息并调整价格的日期，通常在当天开盘前调整净值或报价。",
        "在差价合约产品中，无论是指数、ETF 还是股票类CFD，除息行为都会导致价格调整，因此系统将对持仓客户进行现金补偿或扣款操作。",
      ],
    },
    {
      q: "2. 股息调整的时间",
      a: [
        "指数差价合约股息调整通常会在除息日的00:00-01:00（MT 时间）反映在您的MT4/MT5交易账号中，并标注为“Dividend”。",
        "股票及ETF差价合约股息调整通常会在除息日的16:30（MT 时间）前反映在您的MT5交易账号中，并标注为“Dividend”"
      ],
    },
    {
      q: "3. 股息对指数交易的影响",
      a: [
        "持有多头仓位（买入）：股息调整将存入您的MT4/MT5账号。",
        "持有空头仓位（卖出）：股息调整将从您的MT4/MT5账号扣除。",
        "请注意：ETF产品的股息调整也遵循相同原则，依据基金公司公告的派息数据进行调整。"
      ],
    },
    {
      q: "4. 股息调整的计算公式",
      a: [
        "多头仓位（买入）计算公式：手数 × 合约规格 × 多头股息金额（按指数计价货币计算）",
        "空头仓位（卖出）计算公式：手数 × 合约规格 × 空头股息金额（按指数计价货币计算）",
      ],
    },
    {
      q: "5. 股息调整计算示例",
      a: [
        "以SPXUSD为例，假设其除息日为2024年10月11日，多头股息金额为 0.050美元，空头股息金额为-0.050美元。如果您在除息日前一天(10月10日)收盘时持有1标准手的SPXUSD多头仓位（买入），则股息调整的计算如下：",
        "股息调整 = 1（标准手） × 100（合约规格） × 0.050美元（多头股息金额） = 5美元",
        "在除息日的在除息日的00:00-01:00（MT 时间），5美元将存入您的MT4/MT5账号，备注为“Dividend”。",
        "如果您持有空头仓位（卖出），5美元将从您的MT4/MT5账号中扣除，备注为“Dividend”。",
      ],
    },
    {
      q: "6. 注意事项",
      a: [
        "股息调整适用于指数、ETF和股票类差价合约。",
        "调整金额依据除息日的派息数据、持仓方向和交易手数自动计算并处理。",
        "ETF差价合约的股息金额由其对应基金官方公告决定，可能因标的资产变化而波动。",
        "股息调整不会改变持仓的点差或交易成本，但会影响账户净值和余额。",
        "如需了解特定ETF或指数的除息安排，建议您查看我们的[股息调整明细]或联系您的客户经理。",
      ],
    },
  ],
};
